import FormPage from './FormPage';

export default FormPage;
